import { translate } from "../translations/translations"
import { businessExpenseKeys } from "../models/ExpenseModel"

export interface Label {
  key: string
  labelKey: string
}

export const getLabelsForAssetType = (assetType: string): Label[] => {
  const expenseKeys = businessExpenseKeys[assetType]
  if (!expenseKeys) {
    throw new Error(translate("asset_type_error"))
  }
  return Object.entries(expenseKeys).map(([key, labelKey]) => ({
    key,
    labelKey,
  }))
}

export const validateShipmentsInputs = (data: {
  yearlyVolume?: number
  percentageToTrack?: number
}) => {
  const errors: Record<string, string> = {}
  let isValid = true

  if (typeof data.yearlyVolume !== "number" || data.yearlyVolume < 0) {
    errors.yearlyVolume = translate("yearly_volume_error")
    isValid = false
  }

  if (
    data.percentageToTrack === undefined ||
    data.percentageToTrack < 0 ||
    data.percentageToTrack > 100
  ) {
    errors.percentageToTrack = translate("percentage_to_track_error")
    isValid = false
  }

  return { isValid, errors }
}

export const validateExpenseForm = (
  inputs: Record<string, number>,
  labels: Label[],
): { errors: Record<string, string>; isValid: boolean } => {
  const errors: Record<string, string> = {}
  let isValid = true

  labels.forEach(({ key }) => {
    const value = inputs[key]
    if (value === undefined || value <= 0) {
      errors[key] = translate("required_field_error")
      isValid = false
    }
  })

  return { errors, isValid }
}

export const validateImprovementForm = (
  values: Record<string, number>,
  labels: Label[],
): { errors: Record<string, string>; isValid: boolean } => {
  const errors: Record<string, string> = {}
  let isValid = true

  labels.forEach(({ key }) => {
    const value = values[key]
    if (value === undefined || value === null) {
      errors[key] = translate("required_field_error")
      isValid = false
    } else if (value < 0 || value > 100) {
      errors[key] = translate("value_range_error")
      isValid = false
    }
  })

  return { errors, isValid }
}
